export const LegalTechSkillsProficiencyKeys = {
  None: 'None',
  SomeFamiliarity: 'SomeFamiliarity',
  HighProficiency: 'HighProficiency',
} as const;

export const LegalTechSkillsProficiencies = Object.values(
  LegalTechSkillsProficiencyKeys
);

export const TaxonomyConst = {
  ExplicitPracticeAreaEnums: {
    LegalSupport: 'LegalSupport',
  },
  BusinessTitlesForLegacyJsApiUseOnly: {
    ComplianceProfessional: 'ComplianceProfessional',
    ContractsManager: 'ContractsManager',
    CorporateGovernanceProfessional: 'CorporateGovernanceProfessional',
    DocumentNegotiator: 'DocumentNegotiator',
    Investigator: 'Investigator',
    IPProfessional: 'IPProfessional',
    Lawyer: 'Lawyer',
    LegalEngineer: 'LegalEngineer',
    LegalOperations: 'LegalOperations',
    Paralegal: 'Paralegal',
    PrivacyProfessional: 'PrivacyProfessional',
  },
  BusinessTitleDisplaysForLegacyJsApiUseOnly: {
    ComplianceProfessional: 'Compliance Professional',
    ContractsManager: 'Contracts Manager',
    CorporateGovernanceProfessional: 'Corporate Governance Professional',
    DocumentNegotiator: 'Document Negotiator',
    Investigator: 'Investigator',
    IPProfessional: 'IP Professional',
    Lawyer: 'Lawyer',
    LegalEngineer: 'Legal Engineer',
    LegalOperations: 'Legal Operations',
    Paralegal: 'Paralegal',
    PrivacyProfessional: 'Privacy Professional',
  },
  LawyerBusinessTitle: 'Lawyer',
  LegalTechSkillsProficiencies: {
    [LegalTechSkillsProficiencyKeys.None]: 'None', // does not come from or go to the api (for now)
    [LegalTechSkillsProficiencyKeys.SomeFamiliarity]: 'SomeFamiliarity',
    [LegalTechSkillsProficiencyKeys.HighProficiency]: 'HighProficiency',
  },
  LegalTechSkillsProficienciesOptions: [
    {
      label: 'None',
      value: LegalTechSkillsProficiencyKeys.None,
    },
    {
      label: 'Some',
      value: LegalTechSkillsProficiencyKeys.SomeFamiliarity,
    },
    {
      label: 'High',
      value: LegalTechSkillsProficiencyKeys.HighProficiency,
    },
  ],
  LimitedLegalTechSkillsProficienciesOptions: [
    {
      label: 'High only',
      value: LegalTechSkillsProficiencyKeys.HighProficiency,
    },
  ],
} as const;
